import { Box } from '@chakra-ui/react';
import { Grid } from '@time-line/components/common';
import { useVibeGallery } from 'hooks/useBazaarvoiceGallery';
import type { VibeGallery as VibeGalleryProps } from 'types/cms/blocks/VibeGallery';

export const VibeGallery = ({ galleryName }: VibeGalleryProps) => {
  const { containerRef, isReady } = useVibeGallery(galleryName);

  return (
    isReady && (
      <Grid>
        <Box
          ref={containerRef}
          gridColumn="main"
          my="2xl"
          data-crl8-container-id={galleryName}
          data-crl8-auto-init="false"
        />
      </Grid>
    )
  );
};
